<template>
  <v-card :color="group ? group.color : 'grey'" dark>
    <v-toolbar class="elevation-0" color="#ffffff00" absolute>
      <v-spacer></v-spacer>
      <slot></slot>
    </v-toolbar>
    <v-card-title primary-title>
      <div class="user-info text-xs-center">
        <div class="headline">{{ group ? group.name : '-' }}</div>
        <div v-if="!minimal">{{ group ? group.userCount : 0 }} użytkowników</div>
      </div>
    </v-card-title>
    <v-card-actions v-if="!minimal">
      <v-spacer></v-spacer>
      <v-btn flat :to="`/user/group/${group ? group.id : 0}`">Zobacz użytkowników</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    minimal: {
      type: Boolean,
      default: false
    },
    group: Object
  },
  data: () => ({})
};
</script>